import React from 'react';

/**
  * @desc wraps a string in a <b> HTML tag
  *
  * @param {string} text string to be displayed in bold
  * @param {string} cssClass optional css class to apply to the <b> HTML tag
  *
  * @returns {DOMElement} (JSX) string wrapped in a <b> HTML tag
*/
function boldWrap(text, cssClass = null) {
  return <b key={text} className={cssClass}>{text}</b>;
}
export default boldWrap;
